// src/pages/admin/PaymentsTab.tsx
// Purpose: Placeholder payments dashboard cards. Wire to Stripe (or your provider).

import React, { useState, useEffect } from "react";

const PaymentsTab: React.FC = () => {
  const [revenueSummary, setRevenueSummary] = useState<{ mrr?: number; today?: number; month?: number }>({});

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.debug("[PaymentsTab] simulate fetch revenue");
    // TODO: wire to your billing provider
    setRevenueSummary({ mrr: 1299.0, today: 42.0, month: 880.5 });
  }, []);

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border p-4">
        <div className="text-lg font-medium mb-2">Revenue</div>
        <div className="flex flex-wrap gap-3">
          <div className="rounded-xl border p-3 min-w-[190px]">
            <div className="text-xs text-gray-500">MRR</div>
            <div className="text-lg font-semibold">${revenueSummary.mrr?.toFixed(2) ?? "—"}</div>
          </div>
          <div className="rounded-xl border p-3 min-w-[190px]">
            <div className="text-xs text-gray-500">Today</div>
            <div className="text-lg font-semibold">${revenueSummary.today?.toFixed(2) ?? "—"}</div>
          </div>
          <div className="rounded-xl border p-3 min-w-[190px]">
            <div className="text-xs text-gray-500">This month</div>
            <div className="text-lg font-semibold">${revenueSummary.month?.toFixed(2) ?? "—"}</div>
          </div>
        </div>
        <div className="text-xs text-gray-500 mt-3">Connect Stripe (or provider) to populate live values.</div>
      </div>

      <div className="rounded-2xl border p-4">
        <div className="text-lg font-medium mb-3">Coupons / Promo codes</div>
        <div className="flex gap-3">
          <input className="border rounded px-3 py-2" placeholder="NEWUSER20" />
          <button className="px-3 py-2 rounded-xl border">Create</button>
        </div>
        <div className="text-xs text-gray-500 mt-3">Wire to your billing provider to create/update coupons.</div>
      </div>
    </div>
  );
};

export default PaymentsTab;
